import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("coach_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export function setToken(token) {
    if (token) localStorage.setItem("coach_token", token);
    else localStorage.removeItem("coach_token");
}

export function formatApiError(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export function describeApiError(e) {
    if (!e) return "Something went wrong. Please try again.";
    const detail = e?.response?.data?.detail;
    if (detail != null) return formatApiError(detail);
    const status = e?.response?.status;
    if (status === 401) return "Invalid email or password.";
    if (status === 403) return "You don't have access to that.";
    if (status === 404) return "Not found.";
    if (status === 429) return "Too many attempts — please wait a moment.";
    if (status >= 500) return "Our server hit a snag. Please try again in a moment.";
    if (e.code === "ERR_NETWORK" || e.message === "Network Error")
        return "Can't reach the server. Check your connection and try again.";
    return e.message || "Something went wrong. Please try again.";
}
